import './styles.scss';

export default function BundleResultItem({bundle, className = '', configurationLink=false, pageLink=false, datasheetLink=false, linkToProduct = false}) {
  const resultClass = 'bundle-result-item ' + className
  const image = bundle.thumbnail ?? bundle.image
  const colorImage = bundle.imageColorThumb ?? bundle.imageColor

  const content = <>
    <div className='bundle-image'>
      <img src={image} alt={bundle.title} loading='lazy' decoding='async' />
      {(configurationLink || pageLink || datasheetLink) &&
        <div className='links flex-column justify-content-end'>
          {configurationLink && <a href={bundle.configuratorUrl} className='configurator-link'>{Drupal.tt('configura')}</a>}
          {pageLink && <a href={bundle.pageUrl} className='page-link'>{Drupal.tt('vai alla pagina')}</a>}
          {datasheetLink && <a href={bundle.datasheetUrl} className='page-link' target='_blank' rel='noopener'>{Drupal.tt('scheda tecnica')}</a>}
        </div>
      }
    </div>
    <div className='bundle-content'>
      <div className='bundle-head'>
        <div className='bundle-title'>
          {bundle.collection.name}
        </div>
        <div className='bundle-colors'>
                <span
                  className='color-swatch'
                  style={colorImage ? {backgroundImage: `url(${colorImage})`} : undefined}
                />
          {bundle.mainColors?.length > 1 && (
            <span className='color-count'>
                  +{bundle.mainColors.length-1}
                </span>
          )}
        </div>
      </div>
      <div className='bundle-info'>
        <div className='bundle-description'>
          {bundle.frame.name}, {bundle.version.name}, {bundle.style.name}
        </div>


      </div>
    </div>
  </>

  if(linkToProduct) {
    const href = bundle.pageUrl;
    return <a href={href} className={resultClass}>
      {content}
    </a>
  }
  return <div className={resultClass}>
    {content}
  </div>
}
